import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const doLogin = createAsyncThunk(
    "login/doLogin",
    async (email, {getState}) => {
      /*
      console.log("user", supabase.auth?.user);
      let { user, error } = await supabase.auth.signInWithOtp({
        email: email
      })
      console.log('email-login', user, error);
      user = supabase.auth?.user
      console.log('user', user);
      /*
        let state = getState();
        let session = getSessionId(state);
        */
    }
)

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    loginEmail: "",
    showLoginPrompt: false,
  },
  reducers: {
    setLoginEmail: (slice, action) => {
        slice.loginEmail = action.payload
    },
    requestLogin: (slice) => {
        slice.showLoginPrompt = true;
    },
    cancelLogin: (slice) => {
        slice.showLoginPrompt = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doLogin.pending, (slice) => {
        console.log('dologin.pending')
      })
      .addCase(doLogin.fulfilled, (state, action) => {
        console.log('dologin.fulfilled')
      });
  },
});

export const getLoginEmail = (state) => state.login.loginEmail;
export const showLoginPrompt = (state) => {
  //const user = supabase.auth?.user
  return state.login.showLoginPrompt;
}
export const {setLoginEmail, requestLogin, cancelLogin} = loginSlice.actions;
